import React from "react";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./search-no-results.module.css";

export interface SearchNoResultsProps {
    htmlText: string;
}

export function SearchNoResults(props: SearchNoResultsProps): JSX.Element {
    const { htmlText } = props;

    return (
        <div className={styles.wrapper}>
            <div className={styles.emptyMessage}>
                <h2>
                    <span className={styles.bordered}>
                        {/* Sorry */}
                        {gettext("search.no_results_cannot_filter.title")}
                    </span>
                </h2>
                {/* We couldn't find any in stock products that matched <strong>"{search_query}"</strong>. Try <a {search_oos_link_props}><em>searching for sold out items</em></a> */}
                {/* or */}
                {/* We couldn't find any sold out products that matched <strong>"{search_query}"</strong>. */}
                <p dangerouslySetInnerHTML={{ __html: htmlText }} />
                {/* You might want to double check for typos or try a different search term */}
                <p>{gettext("search.no_results_cannot_filter.advice_text")}</p>
            </div>
        </div>
    );
}
